import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AlertService, ErrorStateService, GlobalConstants, GuidService, LoggingService } from '@app-core';

@Component({
    selector: 'app-error',
    imports: [],
    templateUrl: './error.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './error.component.scss',
})
export class ErrorComponent implements OnInit {
    private readonly errorStateService = inject(ErrorStateService);
    private readonly alertService = inject(AlertService);
    private readonly guidService = inject(GuidService);
    errorHeading = `We're sorry! Something went wrong on our end.`;
    errorBody = `We weren't able to respond to your request.`;
    escMessage = '';
    error: HttpErrorResponse | null = null;
    router: any;

    ngOnInit(): void {
        this.error = this.errorStateService.lastError;
        this.escMessage = GlobalConstants.ERROR_MESSAGES.ESC_MESSAGE;

        if (this.error && this.error.error instanceof ProgressEvent) {
            this.errorHeading = 'Unable to initialize application';
            this.errorBody = GlobalConstants.ERROR_MESSAGES.PROGRESS_ERROR;
        }
    }

    navigateHome() {
        const guid = this.guidService.getGuid();
        LoggingService.log('HeaderComponent', 'navigateHome', 'guid', guid);
        if (guid) {
            this.router.navigate(['parent-response'], { queryParams: { guid } });
        }
    }

    onKeyDown(event: KeyboardEvent): void {
        if (event.key === 'Enter') {
            this.navigateHome();
        }
    }
}
